import {Component, Input, OnInit, NgModule, ViewEncapsulation, Injector, ChangeDetectionStrategy} from '@angular/core';
import {QueryValue} from "../../../../../services/model/queryValue";
import {FilterValue} from "../../../../../services/model/filterValue";
import {EfastFilterBaseComponent} from "../efast-filter-base.component";

@Component({
    selector: 'efast-filter-employer',
    templateUrl: 'efast-filter-employer.component.html',
    styleUrls: ['efast-filter-employer.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class EfastFilterEmployerComponent extends EfastFilterBaseComponent implements OnInit {

    constructor(protected injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.title= this.cacheService.getLabelFromResource('FILTER:FILTEREmployerTitle');

        let filterValues: FilterValue[] = new Array();

        this.filterCategory.filterType = this.staticsService.getFilterType().EMPLOYER;

        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl1'),
            this.staticsService.getEmployerFilter().EMPLOYER_MULTI));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl2'),
            this.staticsService.getEmployerFilter().EMPLOYER_MULTIPLE));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl3'),
            this.staticsService.getEmployerFilter().EMPLOYER_SINGLE));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl4'),
            this.staticsService.getEmployerFilter().EMPLOYER_DFE_ALL));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl5'),
            this.staticsService.getEmployerFilter().EMPLOYER_DFE_MASTER));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl6'),
            this.staticsService.getEmployerFilter().EMPLOYER_DFE_UNABLE));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl7'),
            this.staticsService.getEmployerFilter().EMPLOYER_DFE_GROUP));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl8'),
            this.staticsService.getEmployerFilter().EMPLOYER_DFE_103));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl9'),
            this.staticsService.getEmployerFilter().EMPLOYER_DFE_COM));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl10'),
            this.staticsService.getEmployerFilter().EMPLOYER_DFE_POOLED));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl11'),
            this.staticsService.getEmployerFilter().EMPLOYER_DFE_DCG));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl12'),
            this.staticsService.getEmployerFilter().EMPLOYER_NO_ENTRY));


        this.filterCategory.filterValues = filterValues;

        super.ngOnInit();
    }

    protected expandClick() {
        super.expandClick();
    }

    //extended
    protected searchChangeEvent() {
        this.setBucket(this.applicationService.getAfsForm().facets.plantype.buckets);
        super.searchChangeEvent();
        this.evaluateDfeAllCount();
    }

    private evaluateDfeAllCount() {
        let dfeAllCount: number = 0;
        let dfeAllFilterValue: FilterValue | undefined;
        for (let filterValue  of this.filterCategory.filterValues) {
            if (filterValue.value == this.staticsService.getEmployerFilter().EMPLOYER_DFE_MASTER) {
                dfeAllCount =dfeAllCount + Number(filterValue.count);
            }
            if (filterValue.value == this.staticsService.getEmployerFilter().EMPLOYER_DFE_UNABLE) {
                dfeAllCount =dfeAllCount + Number(filterValue.count);
            }
            if (filterValue.value == this.staticsService.getEmployerFilter().EMPLOYER_DFE_GROUP) {
                dfeAllCount =dfeAllCount + Number(filterValue.count);
            }
            if (filterValue.value == this.staticsService.getEmployerFilter().EMPLOYER_DFE_103) {
                dfeAllCount =dfeAllCount + Number(filterValue.count);
            }
            if (filterValue.value == this.staticsService.getEmployerFilter().EMPLOYER_DFE_COM) {
                dfeAllCount =dfeAllCount + Number(filterValue.count);
            }
            if (filterValue.value == this.staticsService.getEmployerFilter().EMPLOYER_DFE_POOLED) {
                dfeAllCount =dfeAllCount + Number(filterValue.count);
            }
            if (filterValue.value == this.staticsService.getEmployerFilter().EMPLOYER_DFE_DCG) {
                dfeAllCount =dfeAllCount + Number(filterValue.count);
            }
            if (filterValue.value == this.staticsService.getEmployerFilter().EMPLOYER_DFE_ALL) {
                dfeAllFilterValue = filterValue;
            }

        }
        if (dfeAllFilterValue) {
            dfeAllFilterValue.count = dfeAllCount.toString();
        }

    }

    //extended
    protected rowClick(filterValue: FilterValue) {

        super.rowClick(filterValue, true);

        this.queryManagerService.addQueryValueNoSearch(this.staticsService.getCategoryType().EMPLOYER, this.queryValue, true)
    }

}